import angular from "angular"
import React from "react"
import { react2angular } from "react2angular"
import Button from "@paprika/button"
import Unittypefilter from "../unitTypeFilter/unitTypeFilter"
import { useMediaQuery } from "react-responsive"
import Modal from "@paprika/modal"
import "./availabilityStatus.scss"
import { dateAsString, openGemaparkBookingUrl } from "../../shared/utils"
import moment from "moment"
import AvailabilitySummary from "./AvailabilitySummary"
import { getCampsiteNameForBookingUrl } from "../../utils/anytime"

function AvailabilityStatus(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 1023px)" })
  const isTregartonLimited = props.skipIndividualPitchAvailability && props.campsiteName === "tregarton"
  const [isUnitFilterShowing, setIsUnitFilterShowing] = React.useState(
    isMobile && (isTregartonLimited || props.isPitchBookingLimited)
  )
  const [confirmPitchTypeBookingShowing, setConfirmPitchTypeBookingShowing] = React.useState(false)
  const unitDetailsForBookingRef = React.useRef(null)

  const canBookViaUnitTypeList = props.campsiteName !== "tregarton"
  const hideFilterInUnitTypeList = props.skipIndividualPitchAvailability
  // todo if tregarton and skipIndividualPitchAvailability then don't show this
  const renderUnitTypeFilter = () => {
    if (!isTregartonLimited) {
      return (
        <Unittypefilter
          anytimePriceForUnitTypeString={props.anytimePriceForUnitTypeString}
          numOfAvailableMarkersByType={props.numOfAvailableMarkersByType}
          unitsData={props.unitsData}
          unitTypes={props.unitTypes}
          onChange={props.pitchTypeFilterChange}
          isPricingShowing={props.isPricingShowing}
          shouldAllPitchesShowRemaining={props.shouldAllPitchesShowRemaining}
          hideFilter={hideFilterInUnitTypeList}
          onUnitTypeBook={canBookViaUnitTypeList ? handleUnitTypeBook : undefined}
          isPitchBookingLimited={props.isPitchBookingLimited}
        />
      )
    }
    return null
  }

  // should move out into own component
  const renderFilterResultFullScreen = () => (
    <div
      className="unit-filter-overlay"
      style={{
        visibility: isUnitFilterShowing ? "visible" : "hidden",
        pointerEvents: isUnitFilterShowing ? "all" : "none",
      }}
    >
      <Button
        style={{ position: "absolute", right: "10px" }}
        onClick={() => {
          setIsUnitFilterShowing(false)
        }}
      >
        Close
      </Button>
      {renderStatusPanel()}
      {!props.skipIndividualPitchAvailability && (
        <Button
          style={{ width: "70px" }}
          onClick={() => {
            setIsUnitFilterShowing(false)
          }}
        >
          Apply
        </Button>
      )}
    </div>
  )

  const bookByPitchType = () => {
    if (props.bookingDetails.bookingSystemType === "GemaPark") {
      openGemaparkBookingUrl(props.bookingDetails, unitDetailsForBookingRef.current.unitId)
    }
    if (props.bookingDetails.bookingSystemType === "Anytime") {
      let startDateAsMoment = moment(props.bookingDetails.startDate).startOf("day")
      let endDateAsMoment = moment(props.bookingDetails.endDate).startOf("day")
      const startDateAsString = dateAsString(startDateAsMoment, true)
      const lengthOfStay = endDateAsMoment.diff(startDateAsMoment, "days")
      window.open(
        `https://${getCampsiteNameForBookingUrl(props.campsiteName)}.anytimebooking.eu/place_booking/preset/${
          unitDetailsForBookingRef.current.categoryId
        }/${unitDetailsForBookingRef.current.unitId}/${startDateAsString}/${lengthOfStay}`
      )
    }
  }

  // can be refactored move confirm modal into unit filter component
  const handleUnitTypeBook = (item) => {
    unitDetailsForBookingRef.current = { unitId: item.unitId, categoryId: item.categoryId }
    if (props.isPitchBookingLimited) {
      bookByPitchType()
    } else {
      setConfirmPitchTypeBookingShowing(true)
    }
  }

  function getFilterAndBookText() {
    if (!hideFilterInUnitTypeList && canBookViaUnitTypeList) {
      return "Filter & book"
    }
    if (!hideFilterInUnitTypeList && !canBookViaUnitTypeList) {
      return "Filter"
    }
    if (hideFilterInUnitTypeList && canBookViaUnitTypeList) {
      return "Book"
    }
  }

  const renderTregartonBookUnitButton = () => {
    return (
      <>
        <Button
          style={{ marginTop: "12px", width: "100px" }}
          onClick={() => props.bookTregartonSpecificAccomodationType()}
        >
          Book
        </Button>
      </>
    )
  }

  const renderMobileFilterButton = () => {
    if (props.skipIndividualPitchAvailability && props.campsiteName === "tregarton") {
      return <div style={{ marginLeft: "26px" }}>{renderTregartonBookUnitButton()}</div>
    }
    return (
      <Button style={{ marginLeft: "12px", marginTop: "10px" }} onClick={() => setIsUnitFilterShowing(true)}>
        {getFilterAndBookText()}
      </Button>
    )
  }

  const renderStatusPanel = () => {
    return (
      <>
        {isMobile && <span className="title">Pitch Availability</span>}
        {renderUnitTypeFilter()}
        <AvailabilitySummary
          isMobile={isMobile}
          isPitchBookingLimited={props.isPitchBookingLimited}
          minNumberOfNightsForPitchBookings={props.minNumberOfNightsForPitchBookings}
          isTregartonLimited={isTregartonLimited}
        />
        {/* todo should render this button even if props.skipIndividualPitchAvailability is false and show modal like polmanter*/}
        {props.skipIndividualPitchAvailability && props.campsiteName === "tregarton" && renderTregartonBookUnitButton()}
      </>
    )
  }

  return (
    <>
      {isMobile && renderFilterResultFullScreen()}
      {!isMobile && <span className="title">Pitch Availability</span>}
      <div className="availability-status-content">
        <div className="content">
          {confirmPitchTypeBookingShowing && (
            <Modal isOpen onClose={() => setConfirmPitchTypeBookingShowing(false)} size="medium">
              <Modal.Header>Would you like to choose your own pitch?</Modal.Header>
              <Modal.Content style={{ borderTop: 0, boxShadow: "none", borderRadius: 0 }}>
                <div>
                  <p>
                    You can click <strong>‘Book’</strong> below to proceed with your booking, and our team will allocate
                    a suitable pitch based on the facilities you have selected.
                  </p>
                  <p>
                    If you’d prefer to <strong>pick a specific pitch</strong>, please close this box and select your
                    preferred location by clicking on an available pitch (marked with a green dot) for your chosen
                    dates.
                  </p>
                  <Button style={{ marginTop: "10px" }} onClick={bookByPitchType}>
                    Book
                  </Button>
                </div>
              </Modal.Content>
            </Modal>
          )}
          <div className="modify-close-buttons">
            <div
              onClick={() => {
                props.editAvailability()
              }}
            >
              Modify
            </div>
            <div
              onClick={() => {
                props.onClear()
              }}
            >
              Clear
            </div>
          </div>
          <div id="searchInfo">
            <hr />
            <div className="dates">
              <div className="date-row">
                <div className="left-col">Check In</div>{" "}
                <div className="date">
                  {props.startDatePresentable}
                  <i className="calendar-icon fa fa-calendar" />
                </div>
              </div>
              <hr />
              <div className="date-row">
                <div className="left-col">Check Out</div>
                <div className="date">
                  {props.endDatePresentable}
                  <i className="calendar-icon fa fa-calendar" />
                </div>
              </div>
            </div>
          </div>
          {!isMobile ? renderStatusPanel() : renderMobileFilterButton()}
        </div>
      </div>
    </>
  )
}

export default angular
  .module("makeamapAngularApp.availabilitystatusreact", [])
  .component(
    "availabilitystatusreact",
    react2angular(AvailabilityStatus, [
      "bookTregartonSpecificAccomodationType",
      "campsiteName",
      "categoryId",
      "editAvailability",
      "bookingSystemName",
      "onClear",
      "startDatePresentable",
      "endDatePresentable",
      "skipIndividualPitchAvailability",
      "anytimePriceForUnitTypeString",
      "numOfAvailableMarkersByType",
      "unitsData",
      "unitTypes",
      "pitchTypeOptions",
      "pitchTypeFilterChange",
      "minNumberOfNightsForPitchBookings",
      "isPricingShowing",
      "shouldAllPitchesShowRemaining",
      "isPitchBookingLimited",
      "bookingDetails",
    ])
  ).name
